import actionTypes from './actionTypes';

export const setCalendarRange = (range) => ({
  type: actionTypes.CALENDAR_RANGE_SET_DATE_RANGE,
  payload: range,
});

export const resetCalendarRange = () => ({
  type: actionTypes.CALENDAR_RANGE_RESET_DATE_RANGE,
});
